module.exports = __webpack_public_path__ + "img/logos_FOXS.5d197934.png";